import jQuery from 'jquery';

const selector = {
    link: '.js-form-hoverLink',
    row: '.js-form-row',
};
const hoverClass = 'RC-runnerForm__row_hover';

const form = () => {
    jQuery(document).on('mouseenter', selector.link, ({ target }) => {
        jQuery(target).closest(selector.row).addClass(hoverClass);
    });

    jQuery(document).on('mouseleave', selector.link, ({ target }) => {
        jQuery(target).closest(selector.row).removeClass(hoverClass);
    });
};

export default form;



// WEBPACK FOOTER //
// ./lib/js/modules/form/form.js